import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IFetchTransferDetailsParams } from '../../../types';

/**
 * This is to track Transfer Details
 */
export const TRANSFER_DETAILS_QUERY_KEY = 'transfer-details-query-key';

/**
 * This hook fetches the transfer details.
 */
export const useFetchTransferDetails = (
  params: IFetchTransferDetailsParams
) => {
  const {
    inventoryTransferId,
    isConvertToTransferDetails,
    isTrays,
    refetchId,
  } = params || {};
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    enabled: !!inventoryTransferId,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      TRANSFER_DETAILS_QUERY_KEY,
      inventoryTransferId,
      isConvertToTransferDetails,
      isTrays,
      refetchId,
    ],
    networkMode: 'always',
    queryFn: () => INV_MGMT_SERVICE_API.getTransferInfo(params),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
